export default "/_next/static/images/alec-davidian-3be8d3763edf8b1aface4349d3e55911.png";